<section class="nopad">
    <div class="container-fluid register">
        <div class="row text-center">
            <div class="col-md-3 register-left">
                <div class="col-md-12 nopad">
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/AICTELogo.png" alt="Logo" style="margin-left: 25px;"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/SLALogo.png" alt="Logo"></a>
                    <a class="" routerLink='/'><img class="logoImg" src="assets/images/Parakhlogo.png" alt="Logo" style="height: 47px; margin-left: -20px;"></a>
                </div>
                <div class="col-md-12 nopad leftSection">
                    <img class="IconImg" src="https://image.ibb.co/n7oTvU/logo_white.png" alt="" />
                    <h3>Welcome</h3>
                    <p>You are a few seconds away from creating your account!</p>
                    <p>Already a user?</p>
                    <a [routerLink]="['/login']" class="mt-3 registerBtn loginBtn">LOGIN</a>
                </div>
            </div>
            <div class="col-md-9 register-right">
                <form [formGroup]="registerForm" (ngSubmit)="onSubmit(registerForm.value)" class="registerFormContainer">
                    <h2 class="registerHeading">Register Yourself</h2>
                    <div class="row">

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select placeholder="Institute Type" formControlName="institute_type">
                                <mat-option *ngFor="let institute of institutes" [value]="institute.id">{{institute.organization_type}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="registerForm.controls.institute_type.errors && (registerForm.controls.institute_type.touched || registerForm.controls.institute_type.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <div class="col-6" style="text-align: left;">
                            <button type="button" mat-raised-button class="mat-elevation-z6 get-detail-btn" (click)="PIDSelect()">Select Institute
                                PId</button>
                        </div>

                        <!-- <div class="col-6" style="text-align: left;">
                            <button type="button" mat-raised-button class="mat-elevation-z6 get-detail-btn" (click)="getDetails()">Get
                                Details</button>
                        </div> -->
                        <mat-form-field [floatLabel]="'never'" class="col-12">
                            <input readonly matInput placeholder="Institute" formControlName="institute">
                            <mat-error *ngIf="registerForm.controls.institute.errors?.required">Name is required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput placeholder="Student Name" formControlName="name" maxlength="100" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.name.errors?.required">Name is required</mat-error>
                            <mat-error *ngIf="registerForm.controls.name.errors?.minlength">Required (greater than 3
                                characters)</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input  matInput placeholder="Enrollment No" formControlName="enrollment_no" maxlength="100" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.enrollment_no.errors && (registerForm.controls.enrollment_no.touched || registerForm.controls.enrollment_no.dirty)">
                                Required</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput type="text" placeholder="Student Email" formControlName="email" maxlength="100">
                            <mat-error *ngIf="registerForm.controls.email.errors?.required">Email is required</mat-error>
                            <mat-error *ngIf="registerForm.controls.email.errors">Invalid email address</mat-error>
                        </mat-form-field>

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput type="text" placeholder="Student Mobile" (keypress)="checkNumber($event)" formControlName="mobile" maxlength="10" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.mobile.errors && (registerForm.controls.mobile.touched || registerForm.controls.mobile.dirty)">
                                Please enter a valid mobile number.</mat-error>
                        </mat-form-field>

                        <!-- <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input readonly matInput placeholder="Student ID" formControlName="sid">
                            <mat-error *ngIf="registerForm.controls.sid.errors && (registerForm.controls.sid.touched || registerForm.controls.sid.dirty)">
                                    Required</mat-error>
                        </mat-form-field> -->

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select placeholder="Department" formControlName="department">
                                <mat-option *ngFor="let department of departments" [value]="department?.department">{{department?.department}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="registerForm.controls.department.errors && (registerForm.controls.department.touched || registerForm.controls.department.dirty)">
                                Required</mat-error>
                        </mat-form-field>
                        
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <!-- <input matInput placeholder="Year of Admission" formControlName="admission_date"> -->
                            <mat-select placeholder="Year of Admission" formControlName="admission_date">
                                <mat-option *ngFor="let year of years" [value]="year">{{year}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="registerForm.controls.admission_date.errors && (registerForm.controls.admission_date.touched || registerForm.controls.admission_date.dirty)">
                                Required</mat-error>
                        </mat-form-field>                
                
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <mat-select placeholder="Current Year" formControlName="current_year">
                                <mat-option value=1>1<sup>st</sup> Year</mat-option>
                                <mat-option value=2>2<sup>nd</sup> Year</mat-option>
                                <mat-option value=3>3<sup>rd</sup> Year</mat-option>
                                <mat-option value=4>4<sup>th</sup> Year</mat-option>
                                <!-- <mat-option value=5>5<sup>th</sup> Year</mat-option> -->
                            </mat-select>
                            <mat-error *ngIf="registerForm.controls.current_year.errors && (registerForm.controls.current_year.touched || registerForm.controls.current_year.dirty)">
                                Required</mat-error>
                        </mat-form-field>       

                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput matTooltip="The password should contain atleast 1 Upper case, 1 lower case, 1 special symbol and 1 number." [matTooltipPosition]="'left'" placeholder="Set New Password" formControlName="password" type="password" (keypress)="isSpace($event)" minlength="8" maxlength="50" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.password.errors?.required">Password is required
                            </mat-error>
                            <mat-error *ngIf="registerForm.controls.password.errors?.minlength">The password must be
                                atleast 8 characters long.
                            </mat-error>
                            <mat-error *ngIf="registerForm.controls.password.errors?.pattern">It must contain atleast 1
                                lowercase, 1 uppercase, 1 number and 1 special character each.</mat-error>
                        </mat-form-field>
                                
                        <mat-form-field [floatLabel]="'never'" class="col-6">
                            <input matInput placeholder="Confirm Password" formControlName="confirmPassword" type="password" (keypress)="isSpace($event)" minlength="8" maxlength="50" autocomplete="new-password">
                            <mat-error *ngIf="registerForm.controls.confirmPassword.errors?.required">Confirm Password
                                is required</mat-error>
                            <mat-error *ngIf="registerForm.controls.confirmPassword.errors?.pattern || registerForm.controls.confirmPassword.errors?.minlength">It must contain 8 characters with atleast 1
                                lowercase, 1 uppercase, 1 number and 1 special character each.</mat-error>
                            <mat-error *ngIf="registerForm.controls.confirmPassword.hasError('mismatchedPasswords')">
                                Passwords do not match</mat-error>
                        </mat-form-field>

                        <button mat-raised-button class="mat-elevation-z6 w-100 mt-3 registerBtn" type="submit">Register</button>
                    </div>
                </form>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</section>